import { useState, useRef } from "react";
import { registerUser } from "../api/userApi";
import MainLayout from "../../layouts/MainLayout";
import { useNavigate } from "react-router-dom";

function Register() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    mobile_number: "",
    email: "",
    password: "",
    designation: "",
    role: ""
  });

  const [errors, setErrors] = useState({});

  // 👇 refs for auto focus
  const refs = {
    name: useRef(),
    mobile_number: useRef(),
    email: useRef(),
    password: useRef(),
    designation: useRef(),
    role: useRef()
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });

    // remove error on typing
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const validate = () => {
    let newErrors = {};
    let firstErrorField = null;

    Object.keys(form).forEach((key) => {
      if (!form[key]) {
        newErrors[key] = `${key.replace("_", " ")} is required`;

        if (!firstErrorField) {
          firstErrorField = key;
        }
      }
    });

    setErrors(newErrors);

    // 👇 focus first empty field
    if (firstErrorField) {
      refs[firstErrorField]?.current?.focus();
    }

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    await registerUser(form);
    navigate("/account/users");
  };

  return (
    <MainLayout>
      <div className="card p-3 p-md-4 shadow-sm">
        <h3 className="mb-3 h4">Create User</h3>

        <form onSubmit={handleSubmit}>

          <input
            ref={refs.name}
            className={`form-control mb-1 ${errors.name ? "is-invalid" : ""}`}
            name="name"
            placeholder="Name"
            onChange={handleChange}
          />
          <div className="invalid-feedback">{errors.name}</div>

          <input
            ref={refs.mobile_number}
            className={`form-control mb-1 ${errors.mobile_number ? "is-invalid" : ""}`}
            name="mobile_number"
            placeholder="Mobile"
            onChange={handleChange}
          />
          <div className="invalid-feedback">{errors.mobile_number}</div>

          <input
            ref={refs.email}
            className={`form-control mb-1 ${errors.email ? "is-invalid" : ""}`}
            name="email"
            placeholder="Email"
            onChange={handleChange}
          />
          <div className="invalid-feedback">{errors.email}</div>

          <input
            ref={refs.password}
            className={`form-control mb-1 ${errors.password ? "is-invalid" : ""}`}
            name="password"
            type="password"
            placeholder="Password"
            onChange={handleChange}
          />
          <div className="invalid-feedback">{errors.password}</div>

          <input
            ref={refs.designation}
            className={`form-control mb-1 ${errors.designation ? "is-invalid" : ""}`}
            name="designation"
            placeholder="Designation"
            onChange={handleChange}
          />
          <div className="invalid-feedback">{errors.designation}</div>

          <select
            ref={refs.role}
            className={`form-control mb-3 ${errors.role ? "is-invalid" : ""}`}
            name="role"
            onChange={handleChange}
          >
            <option value="">Select Role</option>
            <option value="admin-it">Admin-IT</option>
            <option value="admin">Admin</option>
            <option value="manager">Manager</option>
            <option value="agent">Agent</option>
            <option value="viewer">Viewer</option>
          </select>
          <div className="invalid-feedback d-block">{errors.role}</div>

          <button className="btn btn-primary w-100" type="submit">
            Save User
          </button>

        </form>
      </div>
    </MainLayout>
  );
}

export default Register;